<div ng-controller="userReadlogReportController as ctrl" class="report-generator">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>